import http, { getTenantFromUrl } from "../helpers/http";

export const createUser = async (payload, tenant = getTenantFromUrl()) => {
  let response;
  if (!tenant) {
    response = await http().post("/Account/CreateUser", payload);
  } else {
    const invitePayload = {
      email: payload.emailAddress,
      firstName: payload.firstName,
      lastName: payload.lastName,
      phoneNumber: payload.phoneNumber,
      roleId: payload.roleId,
    };
    response = await http(true).post("/Organisation/staff/invite", invitePayload);
  }
  return response.data;
};

export const getRoles = async (tenant = getTenantFromUrl()) => {
  let response;
  if (!tenant) {
    response = await http().get("/Role/GetRoles");
  } else {
    response = await http(true).get("/Organisation/roles");
  }
  if (Array.isArray(response.data)) {
    return { data: response.data };
  }
  return response.data;
};

export const completeUserCreation = async (payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "User creation completed (Mock)", data: {} };
  }
  const response = await http().post("/Account/CompleteUserCreation", payload);
  return response.data;
};

export const getAllUsers = async (tenant = getTenantFromUrl()) => {
  let response;
  if (!tenant) {
    response = await http().get("/Account/GetUsers");
  } else {
    response = await http(true).get("/Organisation/staff");
  }
  return response.data;
};

export const createRole = async (payload) => {
  const uuid = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' 
    ? crypto.randomUUID() 
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
      });
  const finalPayload = {
    roleId: payload.roleId || uuid,
    ...payload
  };
  const response = await http(true).post("/Organisation/roles", finalPayload);
  return response.data;
};

export const getAvailablePermissions = async () => {
  const response = await http(true).get("/Organisation/permissions/available");
  return response.data;
};

export const getOrgAdminPermissions = async () => {
  const response = await http(true).get("/Organisation/org-admin/permissions");
  return response.data;
};

export const getOrganisationRoles = async () => {
  const response = await http(true).get("/Organisation/roles");
  if (Array.isArray(response.data)) {
    return { data: response.data };
  }
  return response.data;
};
